const dashboardRouter = [
    {
        path: "dashboard",
        name: "dashboard",
        component: () => import("@/views/admin/dashboard"),
        default: true,
        meta: {
            model: "dashboard",
            // requiresAuth: true,
        },
    },
];
export default dashboardRouter;